import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { BaseRespone, PaginationResult } from "src/app/models/common.response";
import { WardService } from "./ward.service";
import { IWard } from "./Iward";

@Injectable({
    providedIn: 'root'
})
export class WardResolver implements Resolve<BaseRespone<{ pagination: PaginationResult, wardDetails: IWard[] }>> {
    /**
     * Constructor
     */
    constructor(private _wardService: WardService) {
    }

    /**
     * Resolver
     *
     * @param route
     * @param state
     */
    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<BaseRespone<{ pagination: PaginationResult, wardDetails: IWard[] }>> {
        var data = {
            pageNumber: 0,
            pageSize: 100,
        };
        return this._wardService.getAllWards(data);
    }
}